// src/components/ConfirmacionPage.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/ConfirmacionPage.css';


const ConfirmacionPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedImages = location.state?.selectedServiceImage || [];
  const difuntoInfo = location.state?.difuntoInfo || null;

  // Calculate total price
  const totalPrice = selectedImages.reduce((sum, item) => {
    const price = parseFloat(item.price) || 0;
    return sum + price;
  }, 0);

  // Lógica para limpiar el título, eliminar 'null' y convertirlo a mayúsculas
  const cleanedTitle = difuntoInfo?.titulo
    ? difuntoInfo.titulo.split(' || ')[0].replace('null', '').trim().toUpperCase()
    : '';

  useEffect(() => {
    if ((!selectedImages || selectedImages.length === 0) && !difuntoInfo) {
      navigate('/');
    }
  }, [selectedImages, difuntoInfo, navigate]);

  const handleGoBack = () => {
    navigate('/', {
      state: {
        openServicios: true,
        restoredSelectedImages: selectedImages,
        restoredDifuntoInfo: difuntoInfo,
        searchState: location.state?.searchState
      }
    });
  };

  const handlePayment = () => {
    navigate('/pasarela-pago', {
      state: location.state
    });
  };

  return (
    <div className="confirmacion-page">
      <div className="confirmacion-content">
        <h2>{t('confirmacionSolicitud')}</h2>

        {difuntoInfo && (
          <div className="difunto-info-section">
            <h4>{t('datosDifunto')}</h4>
            <p>
              <strong className="difunto-name">{cleanedTitle}</strong>
            </p>
            <p>{difuntoInfo.descripcion}</p>
          </div>
        )}

        {selectedImages && selectedImages.length > 0 ? (
          <>
            {/* 1. PRODUCTOS (Con Imagen) */}
            {selectedImages.filter(img => img.src).length > 0 && (
              <div className="section-block">
                <h4>{t('productosTitle')}</h4>
                <ul>
                  {selectedImages.filter(img => img.src).map((img) => (
                    <li key={img.id} className="item-card product-card">
                      <img src={img.src} alt={img.name} className="item-image" />
                      <span className="item-name">{t(img.name)}</span>
                      <span className="item-price">{img.price} €</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* 2. SERVICIOS (Sin Imagen) */}
            {selectedImages.filter(img => !img.src).length > 0 && (
              <div className="section-block">
                <h4>{t('serviciosTitle')}</h4>
                <ul>
                  {selectedImages.filter(img => !img.src).map((img) => (
                    <li key={img.id} className="item-card service-card">
                      <div className="service-icon">🛠️</div>
                      <span className="item-name">{t(img.name)}</span>
                      <span className="item-price">{img.price > 0 ? `${img.price} €` : t('priceConfirmEmail')}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        ) : (
          <p>{t('noItemsError')}</p>
        )}
      </div>

      {selectedImages && selectedImages.length > 0 && (
        <div className="total-price-section">
          <div className="neon-total-box">
            <span className="total-label">{t('total')}:</span>
            <span className="total-amount">{totalPrice.toFixed(2)} €</span>
          </div>
        </div>
      )}

      <div className="confirmation-footer">
        <button onClick={handleGoBack} className="back-button">{t('backButton')}</button>
        <button onClick={handlePayment} className="payment-button">{t('continuePayment')}</button>
      </div>
    </div>
  );
};

export default ConfirmacionPage;